import type { FaireProductEntity } from "../../entity_types/product";

export const p_7qedgs9upw: FaireProductEntity = {
  token: "p_7qedgs9upw",
  type: "product",
  name: "Vintage Afghan Rings - 10 pc.",
  brandToken: "b_592svxunwb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ba799dc66651663b560059126412e4d3b680ff5d60b44de158b828f162ea856b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c55eeb71b3b39671d2d0a3b0a8e6ee2bff3111d544688cf265d48fd80a7c1b83.jpeg",
    "https://cdn.faire.com/fastly/4085d7d347995d1bf9b87d9238c98b76753026080cc88dd4ee3c4dcaf5dda6f8.jpeg",
  ],
  priceDollars: 62.74,
  description:
    "Assortment of 10 vintage tribal rings from Afghanistan.  Please note that each mix will be unique in style and assorted in sizing. Rings may have missing features due to vintage condition. \n\nNo specific requests, please.\n\nMaterial:\ntraditional base metal with featuring assorted stones, vintage glass and plastic",
  tags: [],
  msrpDollars: 125.48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:50.112Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
